import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, DownloadIcon, UsersIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-24 pb-12 px-4 overflow-hidden bg-primary" data-id="element-84">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-86">
          <div className="bg-white text-slate-800 border border-gray-200 shadow-sm px-4 py-1.5 rounded-full text-sm font-semibold mb-4 inline-flex items-center" data-id="element-87">
            🧠 Basado en neurociencia y psicología
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-[56px] font-bold text-slate-900 leading-tight mb-8" data-id="element-88">
            Dejá de vivir con miedo. Tomá el control de tu ansiedad hoy.
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex justify-center mb-8" data-id="element-89">
          <div className="animate-float w-full max-w-sm" data-id="element-90">
            <img src="https://cdn.magicpatterns.com/uploads/eZNq6xUDsPdm9UH1zs4tVd/heylloyd-image-1773856782580.png" alt="Pack Completo — Controla la Ansiedad y los Ataques de Pánico" className="w-full h-auto rounded-2xl shadow-[0_10px_40px_rgba(245,158,11,0.15)]" data-id="element-91" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-center flex flex-col items-center" data-id="element-92">
          <p className="text-text-secondary text-lg sm:text-xl font-normal max-w-[520px] mb-5 leading-relaxed" data-id="element-93">
            El único pack que combina neurociencia, psicología y protocolos de
            intervención inmediata para frenar los ataques de pánico — donde
            estés, cuando sea. Se envía por email en formato PDF.
          </p>

          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="w-full sm:w-auto bg-accent-gold text-white font-bold text-lg sm:text-xl py-4 px-10 rounded-xl glow-gold transition-all duration-300 mb-5" data-id="element-94">
            🧠 QUIERO CONTROLARLO AHORA →
          </button>

          <div className="flex flex-wrap justify-center items-center gap-4 text-text-secondary text-sm" data-id="element-95">
            <div className="flex items-center" data-id="element-96">
              <LockIcon className="w-4 h-4 text-accent-gold mr-1.5" data-id="element-97" /> Pago
              Seguro SSL
            </div>
            <span className="hidden sm:inline text-gray-300" data-id="element-98">·</span>
            <div className="flex items-center" data-id="element-99">
              <DownloadIcon className="w-4 h-4 text-accent-gold mr-1.5" data-id="element-100" />{' '}
              Acceso Inmediato
            </div>
            <span className="hidden sm:inline text-gray-300" data-id="element-101">·</span>
            <div className="flex items-center" data-id="element-102">
              <UsersIcon className="w-4 h-4 text-accent-gold mr-1.5" data-id="element-103" /> +2.300
              personas ya lo tienen
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}